<!-- Replace the full note UI with a compact marker so the anchor's connector line can be used instead of a floating note -->
<span class="note-marker" [attr.data-comment-id]="dataCommentId" title="Comment" aria-hidden="true"></span>
